import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { store } from './config';
//import './sass/tree.css';
import "./bootstrap.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "./style.scss";
import { socket, SocketContext } from './socket';

const App = lazy(() => import('./App'));

ReactDOM.render(
	<React.StrictMode>
		<SocketContext.Provider value={socket}>
			<Provider store={store} >
				<SnackbarProvider maxSnack={2} classes={{
					root: 'useStyles().root',
				}}>
					<Suspense fallback={<div className="app-loading"><div className="loading"></div></div>}>
						<App siteName="Gaming Finest"/>
					</Suspense>
				</SnackbarProvider>
			</Provider>
		</SocketContext.Provider>
  	</React.StrictMode>,
  	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
